import { TopStatisticsItem } from '@ahc-digital/component-library';
import { CreateTopStatisticsItemModel } from './C50TopStatisticsItem.service';
import { C50TopStatisticsItemProps } from './C50TopStatisticsItem.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C50TopStatisticsItemProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = CreateTopStatisticsItemModel(props);

  return (
    <TopStatisticsItem
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C50TopStatisticsItemProps>(Default);
